<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M3 12v8a1 1 0 001 1h5.7l8.75 5.83A1 1 0 0020 26V6a1 1 0 00-1.55-.83L9.7 11H4a1 1 0 00-1 1zm2 1h4v6H5zm13 11.13l-7-4.67v-6.92l7-4.67zM26 8.38a1 1 0 00-1.48 1.35 9.31 9.31 0 010 12.65 1 1 0 00.74 1.67 1 1 0 00.74-.32 11.32 11.32 0 000-15.35z"/><path d="M23.2 11.63A1 1 0 0021.73 13a4.54 4.54 0 010 6.15 1 1 0 00.06 1.41 1 1 0 00.67.26 1 1 0 00.74-.32 6.52 6.52 0 000-8.85z"/></svg>